// extracted by mini-css-extract-plugin
export default {"loginWrapperLeco":"login_loginWrapperLeco__zy9Ji"};